import * as t from 'io-ts';
var regex = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/i;
export var isoDateString = t.brand(t.string, function (s) { return regex.test(s); }, 'IsoDateString');
